import React from "react";
import { Link } from "react-router-dom";
import { productLabel } from "../../utility/brackets/constants";
import { getSetupUrl } from "../../utility/adminNavigation";
import {
  groupSquadsByDate,
  squadDateLabel,
  squadPickerLabel,
  squadTimeLabel,
} from "../ScoringHub/ScoringToolbar/scoringFilterOptions";

const bowlerLabel = (count) =>
  count === 1 ? "1 bowler" : `${count} bowlers`;

const ticketLine = (row, products) => {
  if (!products?.length) {
    return row.ticketCount === 1 ? "1 ticket" : `${row.ticketCount} tickets`;
  }
  if (products.length === 1) {
    return row.ticketCount === 1 ? "1 ticket" : `${row.ticketCount} tickets`;
  }
  return products
    .map((product) => {
      const count = row.ticketsByProduct[product.id] || 0;
      return `${count} ${productLabel(product)}`;
    })
    .join(" · ");
};

const SquadPicker = ({
  tournamentId,
  summaries,
  products,
  canManage,
  onSelect,
  prompt = "Choose a squad.",
}) => {
  if (!summaries?.length) {
    return (
      <p className="text-sm text-brand-charcoal">
        No squads yet.
        {canManage ? (
          <>
            {" "}
            Create squads on{" "}
            <Link className="underline" to={getSetupUrl(tournamentId)}>
              Setup
            </Link>
            .
          </>
        ) : null}
      </p>
    );
  }

  const groups = groupSquadsByDate(summaries.map((row) => row.squad));
  const showDateHeadings = groups.length > 1;

  return (
    <div className="space-y-6">
      <p className="text-sm text-brand-charcoal">{prompt}</p>
      {groups.map((group) => {
        const rows = group.squads
          .map((squad) => summaries.find((row) => row.squad.id === squad.id))
          .filter(Boolean);
        return (
          <div key={group.date || "squads"} className="space-y-2">
            {showDateHeadings ? (
              <h2 className="text-xs font-display font-bold uppercase tracking-wider text-brand-muted">
                {squadDateLabel(group.date)}
              </h2>
            ) : null}
            <ul className="space-y-2">
              {rows.map((row) => (
                <li key={row.squad.id}>
                  <button
                    type="button"
                    onClick={() => onSelect(row.squad.id)}
                    className="w-full text-left card-inset p-4 hover:ring-1 hover:ring-brand-charcoal/20 flex items-center justify-between gap-4"
                  >
                    <div>
                      <div className="font-display font-bold text-brand-charcoal">
                        {showDateHeadings
                          ? squadTimeLabel(row.squad.squadTime)
                          : squadPickerLabel(row.squad)}
                      </div>
                      <div className="text-sm text-brand-muted mt-1">
                        {bowlerLabel(row.bowlerCount)}
                        {" · "}
                        {ticketLine(row, products)}
                        {" · "}
                        {row.shuffled ? "Trees shuffled" : "Sales open"}
                      </div>
                    </div>
                    <span className="text-brand-muted text-lg" aria-hidden="true">
                      →
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default SquadPicker;
